import React from "react";
import { Typography } from "@mui/material";
import PageContainer from "./PageContainer";

const About = () => {
  return (
    <PageContainer>
      <div className="about-container">
        <section className="about-hero">
          <div className="about-hero-content">
            <div className="about-hero-text">
              <Typography sx={{ fontWeight: "bold" }} variant="h3">
                About XSM
              </Typography>
              <div className="about-subtitle">Xccelerated Sports Metrics</div>
            </div>
            <img
              src={
                "https://xsmbasketball.com/wp-content/uploads/2023/05/XSM-Box-Scores.png"
              }
              alt="XSM Logo"
              className="about-hero-image"
            />
          </div>
        </section>

        <section style={{ background: "#1b1b1b" }} className="about-section">
          <h2>Why XSM?</h2>
          <p>
            Xccelerated Sports Metrics (XSM) is the ideal choice for several
            reasons. As the leading company in the field, XSM specializes in
            offering real-time comprehensive data analytics on high school
            athletes across various sports. With a primary focus on basketball
            initially, XSM is dedicated to providing invaluable insights from
            the early years of an athlete's high school career.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            We are committed to creating innovative data-driven solutions that
            help our customers make smarter decisions, train more effectively,
            and ultimately achieve their goals.
          </p>
        </section>

        <section className="about-leadership">
          <h2>Leadership Team</h2>
          <div className="about-leadership-grid">
            <div className="about-leader-card">
              <div className="about-leader-image">
                <img
                  src="https://xsmbasketball.com/wp-content/uploads/2023/05/Chris-Walker.png"
                  alt="Chris Walker - CEO"
                />
              </div>
              <h3>Chris Walker</h3>
              <p>CEO</p>
            </div>

            <div className="about-leader-card">
              <div className="about-leader-image">
                <img
                  src="https://xsmbasketball.com/wp-content/uploads/2023/05/View_recent_photos.jpg"
                  alt="Alan Branch - VP/CBO"
                />
              </div>
              <h3>Alan Branch</h3>
              <p>VP/CBO</p>
            </div>

            <div className="about-leader-card">
              <div className="about-leader-image">
                <img
                  src="https://xsmbasketball.com/wp-content/uploads/2023/10/Kevin-Shelby.png"
                  alt="Kevin Shelby - COO"
                />
              </div>
              <h3>Kevin Shelby</h3>
              <p>COO</p>
            </div>

            <div className="about-leader-card">
              <div className="about-leader-image">
                <img
                  src="https://media.licdn.com/dms/image/v2/C5603AQFJyVOQzFfrCg/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1659424157166?e=2147483647&v=beta&t=mmG-sMEUWybKO2T-5URZ1-mFzGDKy7hImWWidNRgh4k"
                  alt="Eman Igbinosa - CTO"
                />
              </div>
              <h3>Eman Igbinosa</h3>
              <p>CTO</p>
            </div>
          </div>
        </section>
      </div>
    </PageContainer>
  );
};

export default About;
